import * as React from "react";
import { StyledRadioCheckbox } from "styles/Settings";

interface IProps {
  onClick: (key: string, value: number) => void;
  valueKey: string;
  text: string;
  defaultActive?: number;
}
const SettingsRadio = ({ onClick, valueKey, text, defaultActive }: IProps) => {
  const [active, setActive] = React.useState<number | null>(
    defaultActive || null
  );
  const onCheckboxClick = (key: string, value: number, index: number) => {
    onClick(key, value);
    setActive(index);
  };
  React.useEffect(() => {
    if (defaultActive != null) {
      setActive(defaultActive);
    }
  }, [defaultActive]);

  return (
    <tr>
      <td>{text}</td>
      {[0, 1, 2].map((v, i) => (
        <td>
          <StyledRadioCheckbox
            type="checkbox"
            key={i}
            checked={active === i}
            onClick={() => onCheckboxClick(valueKey, v, i)}
          />
        </td>
      ))}
    </tr>
  );
};

export default SettingsRadio;
